import { action, makeAutoObservable, observable } from 'mobx';

class ResultStore {
  cashOutResult = null;
  betResult = {};

  constructor() {
    makeAutoObservable(this, {
      cashOutResult: observable,
      betResult: observable,
      setBetResult: action.bound,
      setCashOutResult: action.bound,
    });
  }

  setCashOutResult(result) {
    this.cashOutResult = result;
  }

  setBetResult(result) {
    this.betResult = result;
  }

  resetResults() {
    this.setCashOutResult(null);
    this.setBetResult(null);
  }
}

export const resultStore = new ResultStore();